import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Feedback } from "../../shared/models/feedback.model";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private static readonly BASE_URL = `${environment.apiUrl}/feedback`;

  constructor(private http: HttpClient) {}

  createFeedback(feedback: Omit<Feedback, 'id' | 'created_at'>): Observable<Feedback> {
    return this.http.post<Feedback>(FeedbackService.BASE_URL, feedback);
  }

  getFeedbacks(): Observable<Feedback[]> {
    return this.http.get<Feedback[]>(FeedbackService.BASE_URL);
  }

  getFeedbackById(id: number): Observable<Feedback> {
    return this.http.get<Feedback>(`${FeedbackService.BASE_URL}/${id}`);
  }

  updateFeedback(id: number, data: Partial<Feedback>): Observable<Feedback> {
    return this.http.put<Feedback>(`${FeedbackService.BASE_URL}/${id}`, data);
  }

  deleteFeedback(id: number): Observable<void> {
    return this.http.delete<void>(`${FeedbackService.BASE_URL}/${id}`);
  }
}